
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { NotificationSearch, NTNotification } from "@nt-portal/server-sdk"
import { AppState } from "./store";

import { initResultData } from "../common";
import { LazyOptions } from "../types";
import { ClientNotificationService } from "../services/modules/core";
import { ResultData, FetchParams, SortDirection } from "@nt-portal/common-sdk";

export interface NotificationCountItem {
    read: boolean;
    count: number
}

export interface NotificationState {
    readonly unread: NTNotification[];
    readonly notifications: ResultData<NTNotification>;
    readonly counts: NotificationCountItem[],
    readonly busy: boolean,
    readonly params: LazyOptions;
    readonly search: NotificationSearch;

}

export const initNotificationState: NotificationState = {
    unread: new Array<NTNotification>(),
    counts: new Array<NotificationCountItem>(),
    busy: false,
    search: {},
    notifications: initResultData<NTNotification>(),
    params: {
        first: 0,
        rows: 50,
        page: 0,
        sortField: 'timeStamp',
        sortOrder: -1
    },
}


const buildFetchParams = (state: NotificationState) => {
    let lazyParams = state.params;
    let fetchParams = new FetchParams();
    fetchParams.limit = lazyParams.rows;
    fetchParams.skip = lazyParams.page && lazyParams.rows ? lazyParams.page * lazyParams.rows : 0
    fetchParams.orderBy = lazyParams.sortField;
    fetchParams.orderDir = lazyParams.sortOrder === 1 ? SortDirection.ASC : SortDirection.DESC
    return fetchParams;
}



export const getNotifications = createAsyncThunk(
    'notifications/getNotifications',
    async (arg: string, { getState }) => {

        let state = getState() as AppState;
        let notificationState = state.notifications;
        let fetchParams = buildFetchParams(notificationState)
        let service = new ClientNotificationService();
        return await service.get(fetchParams, notificationState.search);

    }
)

export const getUnReadNotifications = createAsyncThunk(
    'notifications/getUnReadNotifications',
    async (arg: any, { getState }) => {

        let fetchParams = new FetchParams();
        fetchParams.limit = -1;
        fetchParams.skip = -1;
        fetchParams.orderBy = "timeStamp";
        fetchParams.orderDir = SortDirection.DESC

        let search: NotificationSearch = {
            read: false
        }

        let service = new ClientNotificationService();
        return await service.get(fetchParams, search)

    }
)

export const markNotificationsAsRead = createAsyncThunk(
    'notifications/markNotificationsAsRead',
    async (arg: string[], { getState }) => {



        let service = new ClientNotificationService();
        await service.markAsRead(arg)

        let fetchParams = new FetchParams();
        fetchParams.limit = -1;
        fetchParams.skip = -1;
        fetchParams.orderBy = "timeStamp";
        fetchParams.orderDir = SortDirection.DESC

        return await service.count()


    }
)

export const getNotificationCounts = createAsyncThunk(
    'notifications/getCounts',
    async (arg: any, { getState }) => {

        let service = new ClientNotificationService();
        return await service.count();



    }
)

export const deleteNotification = createAsyncThunk(
    'notifications/deleteNotification',
    async (arg: NTNotification, { getState }) => {

        let service = new ClientNotificationService();
        if (arg.id) {
            await service.delete(arg.id);
        }
        let state = getState() as AppState;
        let notificationState = state.notifications;
        let fetchParams = buildFetchParams(notificationState)
        return await service.get(fetchParams, notificationState.search);

    }
)

const notificationSlice = createSlice({
    name: 'notifications',
    initialState: initNotificationState,
    reducers: {
        setCount(state, action) {
            state.counts = action.payload;
        },
        setNotificationParams(state, action) {
            state.params = action.payload
        },
        setNotificationSearch(state, action) {
            state.search = action.payload;
        }

    },

    extraReducers: (builder) => {
        // Add reducers for additional action types here, and handle loading state as needed
        builder.addCase(getNotifications.pending, (state, action) => {
            // Add user to the state array
            state.busy = true;
            console.log("Loading Notifications")
            state.notifications = { data: [], total: 0, skip: 0, limit: 0 };
        })
        builder.addCase(getNotifications.rejected, (state, action) => {
            // Add user to the state array
            state.busy = false;
        })
        builder.addCase(getNotifications.fulfilled, (state, action) => {
            // Add user to the state array
            state.notifications = action.payload;
            state.busy = false;
              console.log("Loaded Notifications", action.payload.total)

        })
        builder.addCase(deleteNotification.pending, (state, action) => {
            // Add user to the state array
            state.busy = true;
        })
        builder.addCase(deleteNotification.rejected, (state, action) => {
            // Add user to the state array
            state.busy = false;
        })
        builder.addCase(deleteNotification.fulfilled, (state, action) => {
            // Add user to the state array
            state.notifications = action.payload;
            state.busy = false;

        })

        builder.addCase(getUnReadNotifications.pending, (state, action) => {
            // Add user to the state array
            state.busy = true;
        })
        builder.addCase(getUnReadNotifications.rejected, (state, action) => {

            state.busy = false;
        })

        builder.addCase(getUnReadNotifications.fulfilled, (state, action) => {

            state.unread = action.payload.data;
            state.busy = false;
        })

        builder.addCase(markNotificationsAsRead.pending, (state, action) => {

            state.busy = true;
        })
        builder.addCase(markNotificationsAsRead.rejected, (state, action) => {
            state.busy = false;
        })

        builder.addCase(markNotificationsAsRead.fulfilled, (state, action) => {
            state.counts = action.payload;
            state.busy = false;
        })
        builder.addCase(getNotificationCounts.fulfilled, (state, action) => {

             state.counts = action.payload;
        })
        builder.addCase(getNotificationCounts.rejected, (state, action) => {

            state.busy = false;
            console.log(action.error)
        })

    }
});



export const { setCount, setNotificationParams, setNotificationSearch } = notificationSlice.actions;
export default notificationSlice.reducer;